document.addEventListener("DOMContentLoaded", function () {

  const showVideoListing = document.querySelector(".showVideoListing");

  if (showVideoListing) {
    const showVideoListingGlide = document.querySelector(".showVideoListing__slider.glide");
    let totalSlides = 0;

    if (showVideoListingGlide) {

      const svGlide = new Glide(showVideoListingGlide, {
        type: 'slider',
        // autoplay: 5000,
        perView: 4.2,
        perTouch: 1,
        dragThreshold: false,
        // startAt: 0,
        // focusAt: 0,
        // keyboard: false,
        // hoverpause: true,
        // bound: true,
        gap: 38,
        breakpoints: {
          1900: {
            perView: 3.2
          },
          992: {
            perView: 2.2
          },
          768: {
            perView: 2.2,
            dragThreshold: 120,
          },
          480: {
            perView: 1
          }
        }
      });

      svGlide.mount();

    }

  }
});
